if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');
      this.slides = [...this.slider.children];
      this.interval = null;

      this.slider.prepend(this.slides[this.slides.length - 1]);

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', this.handleButtonClick.bind(this));
      }

      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', this.handleButtonClick.bind(this));
      }

      if (window.innerWidth <= 1023) {
        this.autoSlide();
      } 

      window.addEventListener('resize', debounce(() => {
        if (window.innerWidth <= 1025) {
          this.autoSlide();
        } else {
          this.clearAutoSlide(); 
        }
      }, 100).bind(this));
      this.fetchOkendoReviews();
    }

    handleButtonClick(event) {
      this.slides = [...this.slider.children];
      const currentSlide = this.querySelector('.is-selected')
      currentSlide.classList.remove('is-selected');
      let targetSlide;

      if (event.target.classList.contains('announcement-bar__content-nav--left')) {
        targetSlide = currentSlide.previousElementSibling;
        this.slider.prepend(this.slides[this.slides.length - 1]);
      } else if (event.target.classList.contains('announcement-bar__content-nav--right')) {
        targetSlide = currentSlide.nextElementSibling;
        this.slider.append(this.slides[0]);
      }

      targetSlide.classList.add('is-selected');
    }

    autoSlide() {
      const slideTiming = 5000;

      if (this.interval) {
        clearInterval(this.interval);
      }
      
      this.interval = setInterval(() => {
        this.handleButtonClick({ target: this.nextButton });
      }, slideTiming);
    }

    clearAutoSlide() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    fetchOkendoReviews() {
      const url = 'https://api.okendo.io/v1/stores/9534b8d6-2555-40d2-a375-9c6a03b2f02e/review_aggregate';
      const reviewLocation = this.querySelector('.review-text');
      const reviewStoreLink = this.querySelector('.announcement-review');

      fetch(url)
      .then(response => {
        if (!response.ok) {
        throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        const calculatedScore = (data?.reviewAggregate.reviewRatingValuesTotal / data?.reviewAggregate.reviewCount).toFixed(1);
        reviewLocation.innerHTML = `${calculatedScore} from ${data?.reviewAggregate.reviewCount} reviews`;
      })
      .catch(error => {
        console.error('There has been a problem with your fetch operation:', error);
        reviewLocation.style.display = 'none';
      });
    }
  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}